
import { Injectable } from '@angular/core';
import { Department } from '@app/shared/models/admin/department';
import { HttpClientService } from 'app/core/http-client/http-client.service';
import { services } from 'app/core/settings';
import { Language } from 'app/shared/models/admin/language';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PackingPackageService {

  private static readonly endpoint = 'PackingPackage';
  constructor(private http: HttpClientService) { }


  getPackagesByCountryId(countryId: number): Observable<any> {
    return this.http.get(`${PackingPackageService.endpoint}/GetPackagesByCountryId/${countryId}`, undefined, services.orderService)
  }

  list(body: any) {
    return this.http.post(body, `${PackingPackageService.endpoint}/GetPackingPackagePaginatedList`, undefined, services.orderService)
  }

  exportToExcel() {
    return this.http.getForDownloadFile<Blob>(`${PackingPackageService.endpoint}/ExportToExcel`, { responseType: 'blob' }, undefined, services.orderService);
  }

  create(model: Object): Observable<any> {
    return this.http.post(model, `${PackingPackageService.endpoint}/Create`, undefined, services.orderService);
  }

  update(model: object): Observable<any> {
    return this.http.put(model, `${PackingPackageService.endpoint}/Update`, services.orderService);
  }

  delete(id: number) {
    return this.http.delete<boolean>(`${PackingPackageService.endpoint}/Delete/${id}`, undefined, services.orderService);
  }
  GetPackingPackageById(id: number) {
    return this.http.get(`${PackingPackageService.endpoint}/GetPackingPackageById/${id}`, undefined, services.orderService);

  }
  GetAllCountiesHavePackages() {
    return this.http.get(`${PackingPackageService.endpoint}/GetCountriesHavePackages`, undefined, services.orderService);
  }
}
